<template>
  <div>
    <v-checkbox
        class="pt-6"
        :error-messages="error"
        v-model="isChecked"
        :label="translation(translationList.system_security_installed, 'Am un sistem de securitate instalat.')"
    ></v-checkbox>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, type PropType } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'HouseIsSystemSecurityInstalled',
  props: {
    modelValue: {
      type: [Boolean, null] as PropType<boolean | null>,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isChecked = ref(props.modelValue);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();
    const error = ref([]);

    watch(isChecked, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
      isChecked.value = newValue;
      error.value = [];
      const isValid = isChecked.value;
      emit('validation-house-status', { field: 'system_security_installed', isValid });
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      // Listen for validate event
      window.addEventListener('validate-house', (data) => {
        if (data.detail && data.detail === 'system_security_installed') {
          if (!isChecked.value) {
            error.value = [translation(translationList.value.required_house_system_security, 'Te rugăm să citești și să accepți termenii și condițiile de instalare a sistemului de securitate pentru a putea continua')];
          } else {
            error.value = [];
            emit('validation-house-status', { field: 'system_security_installed', isValid: true });
          }
        }
      });
    });

    return {
      isChecked,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>